<template>
  <section class="birthEmployee">
    <h1 class="birthEmployee-title">
      従業員ご本人様の生年月日・性別を入力してください
    </h1>

    <section class="birthEmployee-contain">
      <section class="birthEmployee-row birthEmployee-date">
        <h3>生年月日</h3>
        <article>
          <app-select
            v-model="selectedYear"
            class="birthEmployee-select_year"
            :items="yearItems"
            label="年"
          />
          <app-select
            v-model="selectedMonth"
            class="birthEmployee-select_month"
            :items="monthItems"
            label="月"
            item-text="text"
            item-value="value"
          />
          <app-select
            v-model="selectedDay"
            class="birthEmployee-select_day"
            :items="dayItems"
            label="日"
            item-text="text"
            item-value="value"
          />
        </article>
      </section>
      <v-divider class="birthEmployee-div" />
      <section class="birthEmployee-row birthEmployee-gender">
        <h3>性別</h3>
        <app-radio-group v-model="selectedGender" :items="genderItems" />
      </section>
    </section>
    <section v-if="!isValid" class="birthEmployee-error">
      有効な生年月日を入力してください
    </section>
    <section class="birthEmployee-actions">
      <v-btn class="birthEmployee-ok" :disabled="!isValid" @click="handleSubmit"
        >保険種目選択へ</v-btn
      >
    </section>
  </section>
</template>

<script>
import {
  generateArrayOfYears,
  generateDays,
  generateNumbers,
} from '@/utils/date';

export default {
  name: 'BirthEmployee',
  props: {
    employeeInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      selectedYear: new Date().getFullYear() - 30,
      selectedMonth: 1,
      selectedDay: 1,
      selectedGender: 0,
      genderItems: [
        {
          label: '男性',
          value: 0,
        },
        {
          label: '女性',
          value: 1,
        },
      ],
    }
  },
  computed: {
    isValid() {
      return !!this.dayItems.find((item) => item.value === this.selectedDay);
    },
    yearItems() {
      return generateArrayOfYears(new Date().getFullYear() - 84);
    },
    monthItems() {
      return generateNumbers(1, 12).map((month) => ({
        text: month.toLocaleString('en-US', {
          minimumIntegerDigits: 1,
          useGrouping: false,
        }),
        value: month,
        disabled:
          this.selectedYear === new Date().getFullYear() &&
          month > new Date().getMonth() + 1,
      }));
    },
    dayItems() {
      return generateDays(this.selectedYear, this.selectedMonth).map((day) => ({
        text: day.toLocaleString('en-US', {
          minimumIntegerDigits: 1,
          useGrouping: false,
        }),
        value: day,
        disabled:
          this.selectedYear === new Date().getFullYear() &&
          this.selectedMonth === new Date().getMonth() + 1 &&
          day > new Date().getDate(),
      }));
    },
  },
  mounted() {
    if (this.employeeInfo) {
      this.selectedYear = this.employeeInfo.year;
      this.selectedMonth = this.employeeInfo.month;
      this.selectedDay = this.employeeInfo.day;
      this.selectedGender = this.employeeInfo.gender;
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', {
        year: this.selectedYear,
        month: this.selectedMonth,
        day: this.selectedDay,
        gender: this.selectedGender,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.birthEmployee {
  &-error {
    line-height: 12px;
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
    color: #FF636C;
    caret-color: #FF636C;
    text-align: center;
    margin-top: 10px;
  }
  &-title {
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #666;
    padding-top: 25px;
    margin-bottom: 25px;
  }
  &-row {
    display: flex;
    align-items: baseline;

    article {
      display: flex;
    }
    & > h3 {
      min-width: 129px;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333;
    }
  }

  &-select {
    &_year {
      width: 164px;
    }
    &_month {
      width: 144px;
      margin-left: 34px;
    }
    &_day {
      width: 144px;
      margin-left: 34px;
    }
  }
  &-contain {
    padding: 14px 30px;
    background-color: #f4f4f4;
    border-radius: 10px;
  }
  &-div {
    margin-bottom: 15px;
    margin-top: 8px;
  }
  &-actions {
    display: flex;
    justify-content: center;
    padding: 30px 0;
  }
  &-ok {
    &.v-btn:not(.v-btn--round).v-size--default {
      padding: 14px 44px;
      border-radius: 29px;
      background-color: #CC0000;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 2.6px;
      text-align: left;
      color: #fff;
      width: 244px;
      height: 58px;
      box-shadow: none;
    }
  }
  // mobile
  @media screen and (max-width: 767px) {
    .birthEmployee {
      &-title {
        font-size: 16px;
        width: 70%;
        margin: 10px auto;
        padding-top: 0;
      }
    }
    .appSelect {
      &::v-deep .v-input__icon.v-input__icon--append {
        width: 30px;
        .v-icon {
          font-size: 28px;
        }
      }
      &::v-deep
        .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
        > .v-input__control
        > .v-input__slot {
        min-height: 36px;
        max-height: 36px;
      }
    }
    .appRadioGroup {
      &::v-deep .v-input--radio-group.v-input--radio-group--row .v-radio {
        padding: 5px;
      }
      &::v-deep .v-label.theme--light {
        font-size: 16px;
      }
      &::v-deep .v-input--selection-controls__input .v-icon {
        font-size: 18px;
      }
    }
    &-row {
      flex-direction: column;
      & article {
        flex-wrap: wrap;
      }
    }
    &-contain {
      padding: 15px 15px 7px;
    }
    &-select {
      &_year {
        width: 100%;
        margin-bottom: 10px;
      }
      &_month {
        width: 50%;
        margin-left: 0;
      }
      &_day {
        width: 50%;
        margin-left: 0;
        padding-left: 10px;
      }
    }
  }
}
</style>
